import { createFileRoute } from '@tanstack/react-router'
import { useQuery } from '@tanstack/react-query'
import { useState } from 'react'
import AdminToolbar from '@/src/components/layout/AdminToolbar'
import { me } from '@/src/api/user'
import { usageLogs } from '@/src/api/log'
import { LogsTable } from '@/src/components/manage/usage/LogsTable'
import { LogDetailsDialog } from '@/src/components/manage/usage/LogDetailsDialog'

export const Route = createFileRoute('/_manage/manage/usage/')({
  component: UsagePage,
})

function UsagePage() {
  const [dialogLog, setDialogLog] = useState<any | null>(null)

  const { data: user, isLoading: userLoading } = useQuery({
    queryKey: ['user', 'me'],
    queryFn: () => me(),
  })

  const { data: logsData, isLoading: logsLoading, error: logsError } = useQuery({
    queryKey: ['log', 'usage', { limit: 100 }],
    queryFn: () => usageLogs({ data: { limit: 100 } }),
    enabled: !!user,
  })

  const logs = logsData?.logs ?? []

  return (
    <div className="bg-background text-foreground">
      <AdminToolbar />
      <LogsTable
        logs={logs}
        isLoading={userLoading || logsLoading}
        error={logsError}
        onViewDetails={setDialogLog}
      />
      <LogDetailsDialog
        log={dialogLog}
        open={!!dialogLog}
        onOpenChange={open => !open && setDialogLog(null)}
      />
    </div>
  )
}
